import { render, staticRenderFns } from "./regulatory-release.vue?vue&type=template&id=79bf6c16&scoped=true"
import script from "./regulatory-release.vue?vue&type=script&lang=js"
export * from "./regulatory-release.vue?vue&type=script&lang=js"
import style0 from "./regulatory-release.vue?vue&type=style&index=0&id=79bf6c16&prod&lang=scss&scoped=true"
import style1 from "./regulatory-release.vue?vue&type=style&index=1&id=79bf6c16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bf6c16",
  null
  
)

export default component.exports